import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEImplantcastTargetType, OEImplantcastTargets, OEImplantcastFeatureAccess, OEImplantcastStartSelectionData} from './oe-implantcast-model';

export default class OEImplantcastCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEImplantcastTargetType.op]:       {icon: OEIconCodes.implantcast.opTarget, titleId: 'cap_bar_target_title_op', tooltipId: 'cap_bar_target_tooltip_op'},
            [OEImplantcastTargetType.anatomy]:  {icon: OEIconCodes.implantcast.anatomyTarget, titleId: 'cap_bar_target_title_anatomy', showAlwaysStartSelection: true},
            [OETarget.effigosExplorerHelp]:     {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = [OEImplantcastTargetType.op, OEImplantcastTargetType.anatomy, OETarget.effigosExplorerHelp];

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEImplantcastTargets}
                featureAccess={OEImplantcastFeatureAccess}
                startSelectionData={OEImplantcastStartSelectionData}
            />
        );
    }
}